<template>
    <div class="voice">
        <!-- 顶部导航 -->
        <navbar :navtitle="navtitle"></navbar>
        <!-- 播放器标题 -->
        <h2>{{voice.title}}</h2>
        <!-- 播放器封面 -->
        <div class="cover-img">
            <img src="../../assets/testImg/voice_cover.png" alt="">
        </div>
        <div class="ctrl-box">
            <audio ref="audio" :src="voice.url"></audio>
            <!-- 进度条 -->
            <div class="range-bar">
                <input ref="range" type="range" min="1" max="100" :step="getStep" :value="progressVal">
                <br>
                <span class="now-time">{{secondToMin(curTime)}}</span>
                <span class="all-time">{{secondToMin(allTime)}}</span>
            </div>
            <!--播放器控制按钮 -->
            <div class="controls-items">
            <!-- <img :src="this.preImg" class="preImg" @click="preVoice" />
            <img :src="this.playOrPause" class="playOrPause" @click="myPlay" />
            <img :src="this.nextImg" class="nextImg" @click="nextVoice" /> -->
            <!-- <img src="../../assets/icon/play.png" alt=""> -->
            <i class="iconfont icon-shangyiqu101 item1" @click="preVoice"></i>
            <i class="iconfont icon-zanting item2" v-if="isPlaying" @click="myPlay"></i>
            <i class="iconfont icon-bofang item2" v-else @click="myPlay"></i>
            <i class="iconfont icon-xiayiqu101 item3" @click="nextVoice"></i>
            </div>
        </div>

    </div>
</template>

<script>
// 引入头部导航组件
import navbar from '@/basecomponents/navbar'

import playIMG from '@/assets/icon/play.png'
import pauseIMG from '@/assets/icon/pause.png'
import preIMG from '@/assets/icon/pre.png'
import pre1IMG from '@/assets/icon/pre1.png'
import nextIMG from '@/assets/icon/next.png'
import next1IMG from '@/assets/icon/next1.png'



export default {
    name:'Voice',
    components: {
        navbar,
    },
    data(){
        return {
            navtitle:"",
            timer:null,             // 初始化定时器
            isPlaying: false,       // 判断是否正在播放
            allTime:0,        // 初始化每个音频总时间
            curTime:0,        // 当前播放时间
            curindex:0,             // 当前播放音频的ID
            progressVal:1,          // 进度条初始值
            btnWidth: {  
                type: Number,  
                default: 0  
            },  
            touchInfo: {  
                initiated: false  
            },
            voice:{},           // 音频
            
            preImg: preIMG,
            // pre1Img: pre1IMG,
            playOrPause:playIMG,
            pauseIMG:pauseIMG,
            nextImg: nextIMG,
            // next1Img: next1IMG,
        }
    },
    computed: {
        // 进度条步长
        getStep(){
            return (100/this.allTime);
        },
    },
    // watch: {
    //     // 监测index变化，及时渲染页面
    //     curindex:{  
    //         handler:function(val,oldval){  
    //             var _this = this;
    //             if(this.$refs.audio != null){
    //                 _this.$refs.audio.load();
    //                 _this.$refs.audio.oncanplay = function () {  
    //                     _this.allTime =_this.$refs.audio.duration;
    //                     _this.setTimer();
    //                     console.log(_this.allTime);
    //                 }
                
    //                 this.moveRange();
    //             }
    //         },  
    //         deep:true//对象内部的属性监听，也叫深度监听  
    //     },  
    // },
    created(){
        // 请求声音数据
        var indexArr = this.$store.state.indexArr;
        this.curindex =this.$route.query.id/1;
        this.getVoiceData();
        // this.voiceList = this.$route.query.arr;
        
		// this.voiceList =JSON.parse(localStorage.getItem("voiceList"));
		// console.log(this.voiceList);
		
    },
    mounted(){
        var indexArr = this.$store.state.indexArr;
        this.curindex =this.$route.query.id/1;


        if(this.curindex <= 0){
                this.preImg = pre1IMG;
        };
        var _this = this;
        const audio = this.$refs.audio;
        if(audio != null){
            this.$refs.audio.load();
            this.$refs.audio.oncanplay = function () {  
                _this.allTime =audio.duration;
                _this.setTimer();
            }
        }
        this.moveRange();

        
    },
    methods: {
        // 请求声音数据
        getVoiceData() {
          var _this = this;
            // console.log(_this.curindex);
          _this.$ajax.get('http://114.55.87.60:8187/rest/video/getVideo/' +this.$store.state.indexArr[_this.curindex])
            .then(
              (homeData) => {
                // console.log(homeData.data);
                _this.voice = homeData.data;

              }
            )
        },
        // 播放和暂停
        myPlay() {
            const audio = this.$refs.audio;
            if (this.isPlaying) {
                this.isPlaying = false;
                this.$refs.audio.pause();
                this.playOrPause = playIMG;
            } else {
                this.playOrPause = pauseIMG;
                this.isPlaying = true;
                this.$refs.audio.play();
            }
        },
        // 格式化时间
        secondToMin(s) {　　　　　　　　
          var MM = Math.floor(s / 60);　　　　　　　　
          var SS = s % 60;　　　　　　　　
          if (MM < 10)　　　　　　　　　　 MM = "0" + MM;　　　　　　　　
          if (SS < 10)　　　　　　　　　　 SS = "0" + SS;　　　　　　　　
          var min = MM + ":" + SS;　　　　　　　　
          return min.split('.')[0];　　　　
        },
        // 设置定时器让进度条自动
        setTimer() {
          	var _this = this;
          	clearInterval(_this.timer);　　
          	this.timer = setInterval(() => {
				_this.curTime = this.$refs.audio.currentTime;
				//判断当前播放时间是否等于总时间，相等将暂停图标变为播放
				if (_this.secondToMin(_this.allTime) === _this.secondToMin(_this.curTime)) {
					_this.isPlaying = false;
				}
				_this.progressVal = _this.curTime * 100 / _this.allTime;　　　　　　
				}, 1000)
          	if (_this.secondToMin(_this.allTime) === _this.secondToMin(_this.curTime)) {
            	_this.isPlaying = false;
          }　　
        },
        // 设置滑动进度条改变声音进度
        moveRange(){
            var _this = this;
            this.$refs.range.addEventListener("change",function(){
                _this.$refs.audio.currentTime = this.value*_this.allTime/100;
                _this.$refs.audio.play();
                _this.isPlaying = true;
                
            })
        },
        // 下一声音
        nextVoice(){
            if(this.curindex>=this.$store.state.indexArr.length-1){
                this.nextImg = next1IMG;
                return;
            }
            this.preImg = preIMG;
            // console.log(this.curindex);
            this.isPlaying = false;
            this.curindex+=1;
            this.getVoiceData();
        },
        // 上一声音
        preVoice(){
            if(this.curindex <= 0){
                this.preImg = pre1IMG;  
                return;
            };
            this.nextImg = nextIMG;
            this.isPlaying = false;
            this.curindex-=1;
            this.getVoiceData();
        }
　　　　　　　　
    },
    destroyed(){
        clearInterval(this.timer);
        return false;
        // localStorage.setItem("curindex",this.curindex);
        // localStorage.setItem("curTime",this.curTime);
        
    }

}
</script>

<style lang="scss" scoped>
.voice{
    background-color: #f0f0f0;
    overflow: hidden;
    h2{
        display: flex;
        align-items: center;
        justify-content: center;
        height: 150px;
        margin: 0 auto;
        margin-top: 150px;
        // margin-bottom: 80px;
        text-align: center;
        font-size: 36px;
        font-weight: 700;
        // height: 150px;
        width: 600px;
        line-height: 50px;
        

        // overflow: hidden;
        // text-overflow: ellipsis;
        // white-space: nowrap;
    }
    .cover-img{
        width: 500px;
        height: 500px;
        background-color: #666;
        background-image: url('~assets/testImg/voice_cover.png');
        background-size: contain;
        border-radius: 20px;
        overflow: hidden;
        margin: 0 auto;
        margin-bottom: 50px;
        img{
            width: 500px;
            height: 500px;
        }
    }
    .ctrl-box{
        audio{
            width: 90%;
            margin-left: 5%;

        }
        .range-bar{
            color: #2ba6f2;
            .now-time{
                float:left; 
                margin-left:75px; 
                margin-top:5px;
            }
            .all-time{
                float: right;
                margin-right: 75px;
                margin-top: 5px;
            }
            input[type=range] {
                -webkit-appearance: none;
                margin-left: 10%;
                margin-top: 50px;
                width: 80%;
                height: 10px;
                border-radius: 10px;
                background-color: #666;
            }
            input[type=range]::-webkit-slider-thumb{
                -webkit-appearance: none;
            } 
            input[type=range]::-webkit-slider-runnable-track {
                height: 15px;
                border-radius: 20px;
            }
            input[type=range]:focus {
                outline: none;
            }

            input[type=range]::-webkit-slider-thumb {
                -webkit-appearance: none;
                margin-top: -3px;
                height: 20px;
                width: 20px;
                background: #2ba6f2;
                border-radius: 50%;
                border: solid 3px #fff;
                box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.5);
            }
        }
        .controls-items{
            padding: 0 50px;
            display: flex;
            justify-content: space-around;
            align-items: center;
            margin-top: 50px;
            color: #2ba6f2;
            img{
                width: 125px;
                height: 125px;
            }
            .preImg{
                width: 40px;
                height: 60px;
            }
            .nextImg{
                width: 40px;
                height: 60px;
            }
            i{
                font-size: 70px;
            }
            .item2{
                font-size: 100px;
            }
        }
    
    }

    

}
</style>




// WEBPACK FOOTER //
// src/pages/home/Voice.vue